// extracted by mini-css-extract-plugin
export default {"errorContainer":"ApiErrorsMessages_errorContainer__rMWYL"};